import { IpDataResponse } from "../types";

export class LocationService {
  private static instance: LocationService;
  private readonly IP_DATA_URL = "https://api.ipdata.co";
  private readonly API_KEY: string;

  private constructor(apiKey: string) {
    this.API_KEY = apiKey;
  }

  public static getInstance(apiKey: string): LocationService {
    if (!LocationService.instance) {
      LocationService.instance = new LocationService(apiKey);
    }
    return LocationService.instance;
  }

  public async checkLocationPermission(): Promise<PermissionState> {
    try {
      const permission = await navigator.permissions.query({
        name: "geolocation",
      });
      console.log("permission", permission);
      return permission.state;
    } catch (error) {
      console.error("Error checking permission:", error);
      return "denied";
    }
  }

  public async getBrowserLocation(): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Geolocation is not supported"));
        return;
      }

      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  }

  public async getIpLocation(): Promise<IpDataResponse> {
    try {
      const response = await fetch(
        `${this.IP_DATA_URL}?api-key=${this.API_KEY}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch IP location");
      }
      return await response.json();
    } catch (error: any) {
      throw new Error(`IP location fetch failed: ${error.message}`);
    }
  }
}
